import React from 'react';
import { token } from '@atlaskit/tokens';
import colors from '@atlassian/jira-portfolio-3-common/src/colors/index.tsx';
import DatePicker from '@atlassian/jira-portfolio-3-common/src/date-picker/index.tsx';
import type { Props } from '@atlassian/jira-portfolio-3-common/src/date-picker/types.tsx';

export default function FieldDatePicker({ ...props }: Props) {
	return (
		<DatePicker
			{...props}
			styles={{
				singleValue: (styles) => ({
					...styles,

					...{ color: token('color.text.subtle', colors.N800) },
				}),
			}}
		/>
	);
}
